import { Theme, ThemeOptions, createTheme, lighten } from "@mui/material";

export const MuiButton: any = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      borderRadius: "99px",
      textTransform: "none",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
        outline: `3px solid ${lighten(theme?.palette?.primary?.main, 0.7)}`,
      },
    }),

    sizeLarge: {
      fontSize: "1rem",
    },
  },
};
